import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ContratoService, MonedaService, ComunidadService, UnidadFuncionalService, TenantService } from '../../../../src/app/shared/services';
import { Comunidad, Contrato, GridPageSettings, LocalStorageKeys, MenuFuncionCodes, Moneda, SearchComunidadRequest, SearchContratoRequest } from '../../../../src/app/shared/model';
import { SearchMonedaRequest, SearchUnidadFuncionalRequest, TenantFeatureFlags, TipoContrato, UnidadFuncional, ExportMediaTypeConstants } from '../../../../src/app/shared/model';

@Component({
  selector: 'app-contratoLista',
  templateUrl: './contratoLista.component.html',
  styles: [ ]
})

export class ContratoListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;

  searchForm: FormGroup;

  comunidadList: Comunidad[];
  monedaList: Moneda[];
  tipoContratoList: TipoContrato[];
  ufList: UnidadFuncional[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoContratoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  canAdd: boolean = false;
  canView: boolean = false;
  verSoloActivos: boolean = true;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private tenantService: TenantService,
    private service: ContratoService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.CONTRATO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            if (data.Result.some(x => x == MenuFuncionCodes.CONTRATO_LIST)) {
              this.canAdd = data.Result.some(x => x == MenuFuncionCodes.CONTRATO_ADD);
              this.canView = data.Result.some(x => x == MenuFuncionCodes.CONTRATO_LIST);

              this.loadView();
            } 
            else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.router.navigate(['/']);
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;

    this.buildForm();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    

    this.setQueryParams();

    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getTipos();
    this.getComunidades();
    this.getMonedas();
  }

  getTipos() {
    this.isTipoContratoSearching = true;
    this.service.getTipos().subscribe(data => {
      this.isTipoContratoSearching = false;
      if (data != null)
        this.tipoContratoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoContratoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
            this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Tipo': [null],
      'Codigo': [null],
      'FechaInicioDesde': [null],
      'FechaInicioHasta': [null],
      'MonedaId': [null],
      'ComunidadId': [null],
      'UnidadFuncionalId': [null],
      'UnidadFuncionalCodigo': [null],
      'PersonaNroDocumento': [null],
      'PersonaMovil': [null],
      'PersonaMail': [null],
    });
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Tipo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Tipo;
    else
      this.query.addParams("Tipo",this.searchForm.value.Tipo);
    
    index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Codigo);

    index = this.query.params.findIndex(obj => obj.key === "FechaInicioDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaInicioDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaInicioDesde", this.datePipe.transform(this.searchForm.value.FechaInicioDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaInicioHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaInicioHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaInicioHasta", this.datePipe.transform(this.searchForm.value.FechaInicioHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "PersonaNroDocumento");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PersonaNroDocumento;
    else
      this.query.addParams("PersonaNroDocumento",this.searchForm.value.PersonaNroDocumento);

    index = this.query.params.findIndex(obj => obj.key === "PersonaMovil");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PersonaMovil;
    else
      this.query.addParams("PersonaMovil",this.searchForm.value.PersonaMovil);

    index = this.query.params.findIndex(obj => obj.key === "PersonaMail");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PersonaMail;
    else
      this.query.addParams("PersonaMail",this.searchForm.value.PersonaMail);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalCodigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalCodigo;
    else
      this.query.addParams("UnidadFuncionalCodigo",this.searchForm.value.UnidadFuncionalCodigo);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  onDeudaFiltroUfComunidadSelect() {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    this.searchForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  add() {
    if (this.canAdd)
      this.router.navigate(['contrato-edit', 0]);
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  edit(item: Contrato) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }
    
    this.router.navigate(['contrato-edit', item.Id]);
  }

  onExport() {
    var search = new SearchContratoRequest(null, null, null, "", null, null, null, null, null, null, null, null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Contratos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
